export const SET_CUSTOMER_GOALS = 'SET_CUSTOMER_GOALS'
